export default __webpack_public_path__ + "static/media/Delivery.6975f149.svg";